/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './admin-header.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '../shared/config.service';
import * as import9 from '@angular/core/src/metadata/view';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import12 from '../../../node_modules/@angular/router/src/directives/router_link.ngfactory';
import * as import13 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import14 from '@angular/core/src/linker/template_ref';
import * as import15 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import16 from '@angular/router/src/router';
import * as import17 from '@angular/router/src/router_state';
import * as import18 from '@angular/common/src/location/location_strategy';
import * as import19 from '@angular/common/src/directives/ng_for';
import * as import20 from '@angular/common/src/directives/ng_if';
import * as import21 from '@angular/router/src/directives/router_link';
import * as import22 from '../shared/language-selector.component.ngfactory';
import * as import23 from '@angular/common/src/location/location';
import * as import24 from '../shared/utils.service';
import * as import25 from 'angular2-cookie/services/cookies.service';
import * as import26 from '../shared/language-selector.component';
export class Wrapper_AdminHeaderComponent {
  context:import0.AdminHeaderComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor(p0:any) {
    this.changed = false;
    this.context = new import0.AdminHeaderComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  check_lgRouting(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.lgRouting = currValue;
      this._expr_0 = currValue;
    }
  }
  check_loggedInUser(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.loggedInUser = currValue;
      this._expr_1 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_AdminHeaderComponent_Host:import4.RenderComponentType = (null as any);
class _View_AdminHeaderComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _AdminHeaderComponent_0_4:Wrapper_AdminHeaderComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_AdminHeaderComponent_Host0,renderType_AdminHeaderComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'admin-header',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_AdminHeaderComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._AdminHeaderComponent_0_4 = new Wrapper_AdminHeaderComponent(this.parentInjector.get(import8.ConfigService));
    this._appEl_0.initComponent(this._AdminHeaderComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._AdminHeaderComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.AdminHeaderComponent) && (0 === requestNodeIndex))) { return this._AdminHeaderComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AdminHeaderComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._AdminHeaderComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_AdminHeaderComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_AdminHeaderComponent_Host === (null as any))) { (renderType_AdminHeaderComponent_Host = viewUtils.createRenderComponentType('',0,import9.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_AdminHeaderComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const AdminHeaderComponentNgFactory:import10.ComponentFactory<import0.AdminHeaderComponent> = new import10.ComponentFactory<import0.AdminHeaderComponent>('admin-header',viewFactory_AdminHeaderComponent_Host0,import0.AdminHeaderComponent);
const styles_AdminHeaderComponent:any[] = ([] as any[]);
var renderType_AdminHeaderComponent:import4.RenderComponentType = (null as any);
class _View_AdminHeaderComponent0 extends import3.AppView<import0.AdminHeaderComponent> {
  _text_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _text_32:any;
  _anchor_33:any;
  /*private*/ _appEl_33:import5.AppElement;
  _TemplateRef_33_5:any;
  _NgFor_33_6:import11.Wrapper_NgFor;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _RouterLinkWithHref_41_3:import12.Wrapper_RouterLinkWithHref;
  _text_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _anchor_47:any;
  /*private*/ _appEl_47:import5.AppElement;
  _TemplateRef_47_5:any;
  _NgIf_47_6:import13.Wrapper_NgIf;
  _text_48:any;
  _anchor_49:any;
  /*private*/ _appEl_49:import5.AppElement;
  _TemplateRef_49_5:any;
  _NgIf_49_6:import13.Wrapper_NgIf;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  /*private*/ _expr_68:any;
  /*private*/ _expr_69:any;
  _arr_70:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_AdminHeaderComponent0,renderType_AdminHeaderComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_68 = import1.UNINITIALIZED;
    this._expr_69 = import1.UNINITIALIZED;
    this._arr_70 = import2.pureProxy1((p0:any):any[] => {
      return [p0];
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'       ',(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n        ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,parentRenderNode,'header',new import2.InlineArray2(2,'class','main-header'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n          ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n          ',(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_2,'a',new import2.InlineArray4(4,'class','logo','href','#'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._text_7 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_5,'span',new import2.InlineArray2(2,'class','logo-mini logo-custum'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._el_12 = import2.createRenderElement(this.renderer,this._el_5,'span',new import2.InlineArray2(2,'class','logo-lg logo-custum'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_5,'\n          ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n\n          ',(null as any));
    this._text_16 = this.renderer.createText(this._el_2,'\n          ',(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_2,'nav',new import2.InlineArray4(4,'class','navbar navbar-static-top','role','navigation'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_17,'\n            ',(null as any));
    this._el_20 = import2.createRenderElement(this.renderer,this._el_17,'a',new import2.InlineArray8(8,'class','sidebar-toggle','data-toggle','offcanvas','href','#','role','button'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n              ',(null as any));
    this._el_22 = import2.createRenderElement(this.renderer,this._el_20,'span',new import2.InlineArray2(2,'class','sr-only'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'toggle',(null as any));
    this._text_24 = this.renderer.createText(this._el_20,'\n            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_17,'\n            ',(null as any));
    this._text_26 = this.renderer.createText(this._el_17,'\n            ',(null as any));
    this._text_27 = this.renderer.createText(this._el_17,'\n            ',(null as any));
    this._el_28 = import2.createRenderElement(this.renderer,this._el_17,'div',new import2.InlineArray2(2,'class','navbar-custom-menu'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n              ',(null as any));
    this._el_30 = import2.createRenderElement(this.renderer,this._el_28,'ul',new import2.InlineArray2(2,'class','nav navbar-nav'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._text_32 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._anchor_33 = this.renderer.createTemplateAnchor(this._el_30,(null as any));
    this._appEl_33 = new import5.AppElement(33,30,this,this._anchor_33);
    this._TemplateRef_33_5 = new import14.TemplateRef_(this._appEl_33,viewFactory_AdminHeaderComponent1);
    this._NgFor_33_6 = new import11.Wrapper_NgFor(this._appEl_33.vcRef,this._TemplateRef_33_5,this.parentInjector.get(import15.IterableDiffers),this.ref);
    this._text_34 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._text_35 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._text_36 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._text_37 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._el_38 = import2.createRenderElement(this.renderer,this._el_30,'li',new import2.InlineArray2(2,'class','dropdown user user-menu'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                  ',(null as any));
    this._text_40 = this.renderer.createText(this._el_38,'\n                  ',(null as any));
    this._el_41 = import2.createRenderElement(this.renderer,this._el_38,'a',new import2.InlineArray2(2,'href','#'),(null as any));
    this._RouterLinkWithHref_41_3 = new import12.Wrapper_RouterLinkWithHref(this.parentInjector.get(import16.Router),this.parentInjector.get(import17.ActivatedRoute),this.parentInjector.get(import18.LocationStrategy));
    this._text_42 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._text_43 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._el_44 = import2.createRenderElement(this.renderer,this._el_41,'div',new import2.InlineArray2(2,'class','glyphicon glyphicon-off'),(null as any));
    this._text_45 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._text_46 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._anchor_47 = this.renderer.createTemplateAnchor(this._el_41,(null as any));
    this._appEl_47 = new import5.AppElement(47,41,this,this._anchor_47);
    this._TemplateRef_47_5 = new import14.TemplateRef_(this._appEl_47,viewFactory_AdminHeaderComponent2);
    this._NgIf_47_6 = new import13.Wrapper_NgIf(this._appEl_47.vcRef,this._TemplateRef_47_5);
    this._text_48 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._anchor_49 = this.renderer.createTemplateAnchor(this._el_41,(null as any));
    this._appEl_49 = new import5.AppElement(49,41,this,this._anchor_49);
    this._TemplateRef_49_5 = new import14.TemplateRef_(this._appEl_49,viewFactory_AdminHeaderComponent3);
    this._NgIf_49_6 = new import13.Wrapper_NgIf(this._appEl_49.vcRef,this._TemplateRef_49_5);
    this._text_50 = this.renderer.createText(this._el_41,'\n                  ',(null as any));
    this._text_51 = this.renderer.createText(this._el_38,'\n                ',(null as any));
    this._text_52 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._text_53 = this.renderer.createText(this._el_30,'\n                 ',(null as any));
    this._text_54 = this.renderer.createText(this._el_30,'\n              ',(null as any));
    this._text_55 = this.renderer.createText(this._el_28,'\n            ',(null as any));
    this._text_56 = this.renderer.createText(this._el_17,'\n          ',(null as any));
    this._text_57 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_41,'click',this.eventHandler(this._handle_click_41_0.bind(this)));
    this.init(([] as any[]),[
      this._text_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._text_32,
      this._anchor_33,
      this._text_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._anchor_47,
      this._text_48,
      this._anchor_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._text_57
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.TemplateRef) && (33 === requestNodeIndex))) { return this._TemplateRef_33_5; }
    if (((token === import19.NgFor) && (33 === requestNodeIndex))) { return this._NgFor_33_6.context; }
    if (((token === import14.TemplateRef) && (47 === requestNodeIndex))) { return this._TemplateRef_47_5; }
    if (((token === import20.NgIf) && (47 === requestNodeIndex))) { return this._NgIf_47_6.context; }
    if (((token === import14.TemplateRef) && (49 === requestNodeIndex))) { return this._TemplateRef_49_5; }
    if (((token === import20.NgIf) && (49 === requestNodeIndex))) { return this._NgIf_49_6.context; }
    if (((token === import21.RouterLinkWithHref) && ((41 <= requestNodeIndex) && (requestNodeIndex <= 50)))) { return this._RouterLinkWithHref_41_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_33_0_0:any = ((this.context.config.data == (null as any))? (null as any): this.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_33_6.check_ngForOf(currVal_33_0_0,throwOnChange,false);
    this._NgFor_33_6.detectChangesInInputProps(this,this._anchor_33,throwOnChange);
    const currVal_41_0_0:any = this._arr_70('/admin/login');
    this._RouterLinkWithHref_41_3.check_routerLink(currVal_41_0_0,throwOnChange,false);
    this._RouterLinkWithHref_41_3.detectChangesInInputProps(this,this._el_41,throwOnChange);
    const currVal_47_0_0:any = this.context.loggedInUser;
    this._NgIf_47_6.check_ngIf(currVal_47_0_0,throwOnChange,false);
    this._NgIf_47_6.detectChangesInInputProps(this,this._anchor_47,throwOnChange);
    const currVal_49_0_0:boolean = !this.context.loggedInUser;
    this._NgIf_49_6.check_ngIf(currVal_49_0_0,throwOnChange,false);
    this._NgIf_49_6.detectChangesInInputProps(this,this._anchor_49,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_68:any = import2.interpolate(1,'',((this.context.config.data == (null as any))? (null as any): this.context.config.data.APP.ADMIN.TITLE_MINI),'');
    if (import2.checkBinding(throwOnChange,this._expr_68,currVal_68)) {
      this.renderer.setText(this._text_9,currVal_68);
      this._expr_68 = currVal_68;
    }
    const currVal_69:any = import2.interpolate(1,'',((this.context.config.data == (null as any))? (null as any): this.context.config.data.APP.ADMIN.TITLE),'');
    if (import2.checkBinding(throwOnChange,this._expr_69,currVal_69)) {
      this.renderer.setText(this._text_13,currVal_69);
      this._expr_69 = currVal_69;
    }
    this._RouterLinkWithHref_41_3.detectChangesInHostProps(this,this._el_41,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._RouterLinkWithHref_41_3.context.ngOnDestroy();
  }
  private _handle_click_41_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_41_0:any = ((<any>this._RouterLinkWithHref_41_3.context.onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
    return (true && pd_41_0);
  }
}
export function viewFactory_AdminHeaderComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.AdminHeaderComponent> {
  if ((renderType_AdminHeaderComponent === (null as any))) { (renderType_AdminHeaderComponent = viewUtils.createRenderComponentType('',0,import9.ViewEncapsulation.None,styles_AdminHeaderComponent,{})); }
  return new _View_AdminHeaderComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_AdminHeaderComponent1 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _LanguageSelectorComponent_0_4:import22.Wrapper_LanguageSelectorComponent;
  _text_1:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_AdminHeaderComponent1,renderType_AdminHeaderComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'li',new import2.InlineArray2(2,'language-selector',''),(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import22.viewFactory_LanguageSelectorComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LanguageSelectorComponent_0_4 = new import22.Wrapper_LanguageSelectorComponent(this.parent.parentInjector.get(import8.ConfigService),this.parent.parentInjector.get(import23.Location),this.parent.parentInjector.get(import16.Router),this.parent.parentInjector.get(import24.UtilsService),this.parent.parentInjector.get(import25.CookieService));
    this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context,([] as any[]),compView_0);
    this._text_1 = this.renderer.createText((null as any),'\n                ',(null as any));
    compView_0.create(this._LanguageSelectorComponent_0_4.context,([] as any[]),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'onLanguageSelect',this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
    const subscription_0:any = this._LanguageSelectorComponent_0_4.context.onLanguageSelect.subscribe(this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.LanguageSelectorComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._LanguageSelectorComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parent.context.lgRouting.resourcePath;
    this._LanguageSelectorComponent_0_4.check_resourcePath(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this.parent.context.lgRouting.currentLanguage;
    this._LanguageSelectorComponent_0_4.check_currentLanguage(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = this.context.$implicit;
    this._LanguageSelectorComponent_0_4.check_language(currVal_0_0_2,throwOnChange,false);
    this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_onLanguageSelect_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.lgRouting.onSelect($event)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_AdminHeaderComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_AdminHeaderComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_AdminHeaderComponent2 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_AdminHeaderComponent2,renderType_AdminHeaderComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'span',new import2.InlineArray2(2,'class','hidden-xs'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_2:any = import2.interpolate(1,'',this.parent.context.loggedInUser,'');
    if (import2.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_AdminHeaderComponent2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_AdminHeaderComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_AdminHeaderComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_AdminHeaderComponent3,renderType_AdminHeaderComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'span',new import2.InlineArray2(2,'class','hidden-xs'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'-',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_AdminHeaderComponent3(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_AdminHeaderComponent3(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-header.component.ngfactory.ts